import { flow, get, isEqual, negate } from 'lodash/fp';

export default {
  check: (sourceItem, targetItem) => flow(
    get('itemProduct.productType'),
    negate(isEqual('Custom')),
  )(targetItem),
  errorMessage: (/* sourceItem, targetItem */) => (
    'Product is custom product'
  ),
};
